import styled from 'styled-components';
import { Flex } from '../../../style';

export const LoaderContainer = styled(Flex)`
    position: absolute;
    width: 100%;
    height: 100vh;
    z-index: 99;
`;
